var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M1286.932 925l10.911 10.398.157.002-.001.146 1.001.954-12.068 11.5-.932-.888 10.63-10.131-26.63-.381.014-1.6 25.937.371-9.951-9.483.932-.888z","transform":"translate(-1270 -925)"}))));
}

ArrowInline.defaultProps = {"width":"29","height":"23","viewBox":"0 0 29 23"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
